/**
 * Auto Rage Click — 분노 클릭 감지
 * 같은 좌표(+-10px) 2초 내 3회 이상 클릭
 */

import { getElementText } from "./utils";

var RADIUS = 10; // px 허용 범위
var TIME_WINDOW = 2000; // 2초
var MIN_CLICKS = 3;

export function initRageClick(mixpanel) {
  var clicks = []; // { x, y, time }
  var lastRageTime = 0;

  function handler(event) {
    try {
      var now = Date.now();
      var x = event.clientX;
      var y = event.clientY;
      var target = event.target;

      // 오래된 클릭 제거
      clicks = clicks.filter(function (c) {
        return now - c.time < TIME_WINDOW;
      });

      clicks.push({ x: x, y: y, time: now });

      // 같은 좌표 범위 내 클릭 수 확인
      var nearby = clicks.filter(function (c) {
        return Math.abs(c.x - x) <= RADIUS && Math.abs(c.y - y) <= RADIUS;
      });

      if (nearby.length >= MIN_CLICKS && now - lastRageTime > TIME_WINDOW) {
        lastRageTime = now;

        var trackFn = function () {
          try {
            mixpanel.track("Auto Rage Click", {
              element_tag: target.tagName ? target.tagName.toLowerCase() : "",
              element_text: getElementText(target),
              click_count: nearby.length,
              route_path: window.location.pathname,
            });
          } catch (e) {
            // 무시
          }
        };

        if (typeof requestIdleCallback === "function") {
          requestIdleCallback(trackFn);
        } else {
          setTimeout(trackFn, 0);
        }
      }
    } catch (e) {
      // 핸들러 에러가 서비스로 전파되지 않도록
    }
  }

  document.addEventListener("click", handler, { passive: true, capture: true });
}
